import { Component, Input, OnInit } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

//INTERFACE
import { trackByLabel } from '../../../shared/util/track-by.util';
import { EChannelFilterComparisonOperators } from '../../interfaces/channel.interface';

//UTIL

@Component({
  selector: 'lum-channel-form-filters',
  templateUrl: './channel-form-filters.component.html',
  styleUrls: ['./channel-form-filters.component.scss'],
})
export class ChannelFormFiltersComponent implements OnInit {
  @Input() formData :UntypedFormGroup;

  comparisonOperators :{ value :string | null; label :string }[];
  public filterConditions :{ label :string; value :string }[] = [
    { label: 'EQUAL', value: 'EQ' },
    { label: 'NOT EQUAL', value: 'NEQ' },
    { label: 'IN', value: 'IN' },
    { label: 'NOT IN', value: 'NIN' },
    { label: 'GREATER THAN', value: 'GT' },
    { label: 'LESSER THAN', value: 'LT' },
  ];

  trackByLabel = trackByLabel;

  constructor(private fb :UntypedFormBuilder) {}

  ngOnInit() :void {
    this.comparisonOperators = Object.entries(
      EChannelFilterComparisonOperators,
    ).map(([label, value]) => {
      return {
        value: value,
        label: label,
      };
    });
  }

  get channelFilters() :UntypedFormArray {
    return this.formData.get('filters') as UntypedFormArray;
  }

  onRemoveFilters(idx :number) {
    this.channelFilters.removeAt(idx);
  }

  onAddFilter() {
    const filters :UntypedFormArray = this.formData.get(
      'filters',
    ) as UntypedFormArray;
    const row :UntypedFormGroup = this.fb.group({
      key: ['', Validators.required],
      value: ['', Validators.required],
      condition: ['EQ', Validators.required],
    });
    filters.push(row);
  }
}
